export const CODRIVER_REQUEST_ATTRIBUTES = [
    'driver_ids',
    'result_from',
    'result_to',
    'vehicle_ids',
];
